export default "__VITE_ASSET__BlGUrHbk__"